// extracted by mini-css-extract-plugin
export default {"lease":"lease-ba3e"};